export default {
  // Page title
  title: 'Template Settings',

  // Search filter area
  search: {
    // Search condition labels
    templateName: 'Template Name',
    templateId: 'Template ID',
    cloudStorageId: 'Cloud Storage ID',
    applicableBranch: 'Applicable Branch',
    applicableCompany: 'Applicable Company',
    templateType: 'Template Type',

    // Placeholders
    placeholder: {
      enterTemplateName: 'Please enter template name',
      enterTemplateId: 'Please enter template ID',
      enterCloudStorageId: 'Please enter cloud storage ID',
      selectApplicableBranch: 'Please select applicable branch',
      selectApplicableCompany: 'Please select applicable company',
      selectTemplateType: 'Please select template type',
      selectTemplateUsage: 'Please select template usage'
    },

    // Buttons
    search: 'Search',
    reset: 'Reset'
  },

  // Action button area
  actions: {
    addTemplate: 'Add Template',
    batchDelete: 'Batch Delete',
    totalRecords: 'Total {count} records'
  },

  // Table column headers
  table: {
    columns: {
      templateId: 'Template ID',
      templateName: 'Template Name',
      cloudStorageId: 'Cloud Storage ID',
      applicableBranch: 'Applicable Branch',
      applicableCompany: 'Applicable Company',
      templateType: 'Template Type',
      templateEngine: 'Template Engine',
      templateUsage: 'Template Usage',
      remarks: 'Remarks',
      actions: 'Operations'
    },

    placeholders: {
      noTemplate: 'No template data'
    },

    // Template usage labels
    usage: {
      print: 'Print',
      email: 'Email'
    },

    // Operation buttons
    actions: {
      edit: 'Edit',
      copy: 'Copy',
      more: 'More',
      config: 'Config',
      delete: 'Delete'
    }
  },

  // Modal
  modal: {
    title: {
      add: 'Add Template',
      edit: 'Edit Template'
    },

    // Button texts
    okText: 'Confirm',
    cancelText: 'Cancel',

    // Form fields
    form: {
      templateChineseName: 'Template Chinese Name',
      templateEnglishName: 'Template English Name',
      applicableBranch: 'Applicable Branch',
      applicableCompany: 'Applicable Company',
      templateType: 'Template Type',
      templateUsage: 'Template Usage',
      cloudStorageId: 'Cloud Storage ID',
      uploadFile: 'Upload File',
      uploading: 'Uploading...',
      remarks: 'Remarks',

      // Placeholders
      placeholder: {
        enterTemplateChineseName: 'Please enter template Chinese name',
        enterTemplateEnglishName: 'Please enter template English name',
        selectApplicableBranch: 'Please select applicable branch',
        selectApplicableCompany: 'Please select applicable company',
        selectTemplateType: 'Please select template type',
        selectTemplateUsage: 'Please select template usage',
        enterCloudStorageId: 'Please enter cloud storage ID',
        enterRemarks: 'Please enter remarks'
      }
    }
  },

  // Template selection dialog
  selection: {
    templateName: 'Template Name',
    templateType: 'Template Type',
    title: 'Select Template',
    searchPlaceholder: 'Please enter template name',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },

  // Confirmation dialogs
  confirm: {
    delete: {
      title: 'Confirm Delete',
      content: 'Are you sure you want to delete template "{name}"? This action cannot be undone.',
      batchContent: 'Are you sure you want to delete {count} selected templates? This action cannot be undone.',
      okText: 'Confirm',
      cancelText: 'Cancel'
    }
  },

  // Message prompts
  message: {
    success: {
      create: 'Template created successfully',
      update: 'Template updated successfully',
      delete: 'Template deleted successfully',
      batchDelete: 'Successfully deleted {count} templates',
      copy: 'Template copied successfully',
      config: 'Report configuration page opened successfully',
      upload: 'File uploaded successfully; Cloud Storage ID filled automatically'
    },
    error: {
      loadFailed: 'Data loading failed, please try again later',
      createFailed: 'Template creation failed',
      updateFailed: 'Template update failed',
      deleteFailed: 'Template deletion failed',
      batchDeleteFailed: 'Batch deletion failed',
      operationFailed: 'Operation failed, please try again later',
      copyFailed: 'Template copy failed',
      configFailed: 'Failed to configure template, please try again later',
      uploadNoStorageId: 'Cloud Storage ID was not returned',
      uploadFailed: 'File upload failed, please try again',
      loadOfficeTreeFailed: 'Failed to load organization structure, please try again later'
    },
    warning: {
      noTemplateId: 'Template ID cannot be empty',
      noSelection: 'Please select templates to delete first'
    },
    info: {
      copyNotImplemented: 'Copy feature not implemented yet',
      configNotImplemented: 'Configure feature not implemented yet'
    }
  }
}
